import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_ADMIN, ROLE_STAFF_USER } from '@/util/roles';

export const routes = [
	{
		path: 'companies',
		meta: {
			requireAuth: true,
			breadcrumb: 'Companies',
		},
		children: [
			{
				path: '',
				name: ROUTE_NAMES.DEPOT.COMPANIES.DASHBOARD,
				component: () => {
					return import('@/views/depot/companies/Dashboard.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: '',
				},
			},
			{
				path: 'all-companies',
				name: ROUTE_NAMES.DEPOT.COMPANIES.OVERVIEW,
				component: () => {
					return import('@/views/depot/companies/All-Companies.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'All Companies',
				},
			},
			{
				path: 'browse',
				name: ROUTE_NAMES.DEPOT.COMPANIES.BROWSE,
				component: () => {
					return import('@/views/depot/companies/Browse.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Browse',
				},
			},
			{
				path: 'browse/:letter',
				name: ROUTE_NAMES.DEPOT.COMPANIES.BROWSE_LETTER,
				component: () => {
					return import('@/views/depot/companies/Browse-Letter.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Browse Letter',
				},
			},
			{
				path: 'add-company',
				name: ROUTE_NAMES.DEPOT.COMPANIES.ADD_COMPANY,
				component: () => {
					return import('@/views/depot/companies/Add-Company.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Add Company',
					// Creating one company is routine staff work. The three bulk
					// maintenance jobs below rewrite many records and stay at
					// ROLE_ADMIN; that is the line, not read versus write.
					minRole: ROLE_STAFF_USER,
				},
			},
			{
				path: 'fix-site-naming',
				name: ROUTE_NAMES.DEPOT.COMPANIES.FIX_SITE_NAMING,
				component: () => {
					return import('@/views/depot/companies/Fix-Site-Naming.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Fix Site Naming',
					minRole: ROLE_ADMIN,
				},
			},
			{
				path: 'dedupe-sites',
				name: ROUTE_NAMES.DEPOT.COMPANIES.DEDUPE_SITES,
				component: () => {
					return import('@/views/depot/companies/Dedupe-Sites.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Dedupe Sites',
					minRole: ROLE_ADMIN,
				},
			},
			{
				path: 'sync-profile-ownership',
				name: ROUTE_NAMES.DEPOT.COMPANIES.SYNC_PROFILE_OWNERSHIP,
				component: () => {
					return import('@/views/depot/companies/Sync-Profile-Ownership.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Sync Profile Ownership',
					minRole: ROLE_ADMIN,
				},
			},
		],
	},
];
